import React, { useEffect, useState } from "react";
import api, { rupee, downloadFile } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Heart, MapPin, Crown, Download } from "lucide-react";
import { toast } from "sonner";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  const [detail, setDetail] = useState(null);

  useEffect(() => { api.get("/admin/customers").then((r) => setCustomers(r.data)); }, []);
  const open = async (id) => { const { data } = await api.get(`/admin/customers/${id}`); setDetail(data); };
  const exportXlsx = async () => { try { await downloadFile("/admin/customers/export/xlsx", "customers.xlsx"); } catch { toast.error("Export failed"); } };

  return (
    <div data-testid="admin-customers">
      <div className="flex justify-between items-center mb-6">
        <h1 className="font-serif text-3xl text-navy">Customers</h1>
        <button onClick={exportXlsx} data-testid="export-customers-btn" className="flex items-center gap-2 bg-navy text-cream text-sm font-semibold px-4 py-2.5 rounded-full hover:bg-navy-soft transition-colors"><Download size={15} /> Export Excel</button>
      </div>
      <div className="bg-white rounded-xl border border-black/5 overflow-x-auto">
        <table className="w-full min-w-[680px] text-sm">
          <thead className="bg-beige text-navy text-left"><tr><th className="p-3">Name</th><th className="p-3">Contact</th><th className="p-3">Orders</th><th className="p-3">Total Spend</th><th className="p-3">AOV</th><th className="p-3">Joined</th><th className="p-3"></th></tr></thead>
          <tbody>
            {customers.length === 0 ? <tr><td colSpan={7} className="p-8 text-center text-muted-foreground">No customers yet</td></tr> :
              customers.map((c) => (
                <tr key={c.id} className="border-t border-black/5 hover:bg-beige/40" data-testid={`customer-${c.id}`}>
                  <td className="p-3 font-medium text-navy">{c.name}</td>
                  <td className="p-3"><div className="text-navy">{c.email || "—"}</div><div className="text-xs text-muted-foreground">{c.phone || "—"}</div></td>
                  <td className="p-3">{c.orders}</td>
                  <td className="p-3 font-medium text-navy">{rupee(c.total_spend)}</td>
                  <td className="p-3">{rupee(c.aov)}</td>
                  <td className="p-3 text-muted-foreground">{c.created_at ? new Date(c.created_at).toLocaleDateString("en-IN") : "—"}</td>
                  <td className="p-3"><button onClick={() => open(c.id)} data-testid={`view-customer-${c.id}`} className="text-xs font-semibold text-navy hover:text-gold">View</button></td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <Dialog open={!!detail} onOpenChange={(o) => !o && setDetail(null)}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
          {detail && (<>
            <DialogHeader><DialogTitle className="font-serif text-2xl">{detail.name}</DialogTitle></DialogHeader>
            <div className="space-y-4 text-sm">
              <div className="text-muted-foreground">{detail.email || "—"} · {detail.phone || "—"}</div>
              <div className="flex gap-3">
                <div className="flex-1 bg-navy text-cream rounded-lg p-3"><div className="text-xs text-cream/60">Total Spend</div><div className="font-serif text-xl text-gold">{rupee(detail.total_spend)}</div></div>
                <div className="flex-1 bg-beige rounded-lg p-3"><div className="text-xs text-muted-foreground flex items-center gap-1"><Crown size={12} className="text-gold" /> Loyalty</div><div className="font-serif text-xl text-navy">{detail.loyalty_points} pts</div></div>
              </div>
              <div>
                <div className="font-semibold text-navy mb-2 flex items-center gap-1.5"><Heart size={14} className="text-gold" /> Favourite Items</div>
                {detail.favourites.length === 0 ? <div className="text-xs text-muted-foreground">No orders yet</div> :
                  <div className="flex flex-wrap gap-2">{detail.favourites.map((f, i) => <span key={i} className="text-xs bg-beige px-2.5 py-1 rounded-full">{f.name} ×{f.count}</span>)}</div>}
              </div>
              <div>
                <div className="font-semibold text-navy mb-2 flex items-center gap-1.5"><MapPin size={14} className="text-gold" /> Saved Addresses</div>
                {detail.addresses.length === 0 ? <div className="text-xs text-muted-foreground">No saved addresses</div> :
                  detail.addresses.map((a) => <div key={a.id} className="text-xs bg-beige rounded p-2 mb-1">{a.label}: {a.address}, {a.city} - {a.pincode}</div>)}
              </div>
              <div>
                <div className="font-semibold text-navy mb-2">Recent Orders</div>
                {detail.orders.slice(0, 6).map((o) => (
                  <div key={o.id} className="flex justify-between border-b border-dashed border-black/10 py-1.5"><span className="text-navy">{o.order_number} <span className="text-xs text-muted-foreground capitalize">· {o.status.replace(/_/g, " ")}</span></span><span className="text-muted-foreground">{rupee(o.grand_total)}</span></div>
                ))}
              </div>
            </div>
          </>)}
        </DialogContent>
      </Dialog>
    </div>
  );
}
